<template>
    <DefaultTemplate>
        <div class="column" :class="maxWidth > 768 ? '':'pd-3'">
        <b-loading :active.sync="isLoadingPage"></b-loading>
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <div class="card rounded signup text-center">
                    <h2>สมัครสมาชิก</h2>
                    <div class="columns has-text-left flex-warp mg-t-4">
                        <div class="column is-6 ">
                            <BInputWithValidation
                                rules="required"
                                label="ชื่อ"
                                v-model="form.name"
                            />
                        </div>
                        <div class="column is-6">
                            <BInputWithValidation
                                rules="required"
                                label="นามสกุล"
                                v-model="form.surname"
                            />
                        </div>
                        <div class="column is-6 ">
                            <BInputWithValidation rules="required|email" type="email" label="อีเมล" v-model="form.email"/>
                        </div>
                        <div class="column is-6 " />
                        <div class="column is-6 ">
                            <BInputWithValidation
                                rules="required|min:8"
                                type="password"
                                label="รหัสผ่าน"
                                vid="password"
                                v-model="form.password"
                            />
                        </div>
                        <div class="column is-6">
                            <BInputWithValidation
                                rules="required|confirmed:password"
                                name="Password"
                                type="password"
                                label="ยืนยันรหัสผ่าน"
                                v-model="form.confirmPassword"
                            />
                        </div>
                        <div class="column is-6 ">
                            <b-field label="ตำแหน่งงาน">
                                <b-input v-model="form.position"></b-input>
                            </b-field>
                        </div>
                        <div class="column is-6">
                            <b-field label="สังกัดหน่วยงาน">
                                <b-input v-model="form.department"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <b-button @click="passes(signup)"  :style="styleObject" class="mg-t-4 button-secondary">สมัครสมาชิก</b-button>
                    <p class="pd-t-2">หากคุณมีบัญชีเพื่อเข้าใช้งานระบบแล้ว? <a href="/">เข้าสู่ระบบ</a></p>
                </div>
            </ValidationObserver>
        </div>
    </DefaultTemplate>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BInputWithValidation from "@/components/inputs/BInputWithValidation";
import DefaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";
import {
    alertSignupSuccess,
    alertSignupFail,
    alertSignupEmailFail,
    alertCatchError
} from "@/service/alert";

export default {
    components:{
        DefaultTemplate,
        ValidationObserver,
        BInputWithValidation
    },
    data() {
        return {
            form:{
                name:'',
                surname:'',
                email:'',
                password:'',
                confirmPassword:'',
                department:'',
                position:''
            },
            isLoadingPage:false
        }
    },
    methods: {
        signup(){
            this.isLoadingPage = true

            let obj = {
                email:this.form.email,
                name: this.form.name,
                surname:this.form.surname,
                password:this.form.password,
                department:this.form.department,
                position:this.form.position,
                userLevel:60
            }

            HTTP.post(`sign/up`, obj)
            .then((res) => {
                console.log('signup',res)
                if (res.data.success) {
                    this.alertSignupSuccess()
                }else if(res.data.data == 'email is not work.'){
                    this.alertSignupEmailFail()
                }else{
                    this.alertSignupFail()
                }
            })
            .catch((e) => {
                this.alertCatchError()
            })
            .finally(() => {
                this.isLoadingPage = false
            })
        },
    },
}
</script>